import {
  consoleLoggingIntegration,
  init,
  reactRouterV6BrowserTracingIntegration,
  replayIntegration
} from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import {
  SENTRY_DSN,
  SENTRY_ENABLED,
  SENTRY_ENV,
  SENTRY_LOGS_ENABLED,
  SENTRY_REPLAYS_ENABLED,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
  SENTRY_SEND_DEFAULT_PII,
  SENTRY_TRACE_PROPAGATION_DOMAIN,
  SENTRY_CONSOLE_LOG_LEVELS,
  SENTRY_TRACES_SAMPLE_RATE,
  SENTRY_RELEASE_VERSION
} from './config';
import { isLocalhost } from './serviceWorker';

if (SENTRY_DSN && SENTRY_ENABLED && !isLocalhost) {
  const integrations = [
    reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    })
  ];

  if (SENTRY_LOGS_ENABLED) {
    integrations.push(
      consoleLoggingIntegration({
        levels: SENTRY_CONSOLE_LOG_LEVELS.split(',').map((l: string) =>
          l.trim()
        )
      })
    );
  }

  if (SENTRY_REPLAYS_ENABLED) {
    integrations.push(replayIntegration());
  }

  init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENV || undefined,
    release: SENTRY_RELEASE_VERSION || undefined,
    sendDefaultPii: SENTRY_SEND_DEFAULT_PII,
    replaysSessionSampleRate: SENTRY_REPLAYS_ENABLED
      ? Number(SENTRY_REPLAYS_SESSION_SAMPLE_RATE)
      : 0,
    replaysOnErrorSampleRate: SENTRY_REPLAYS_ENABLED
      ? Number(SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE)
      : 0,
    integrations,
    enableLogs: SENTRY_LOGS_ENABLED,
    tracePropagationTargets: [
      /^\//,
      new RegExp(
        `^https:\\/\\/.*\\.${SENTRY_TRACE_PROPAGATION_DOMAIN.replace(
          /\./g,
          '\\.'
        )}`
      )
    ],
    tracesSampleRate: Number(SENTRY_TRACES_SAMPLE_RATE)
  });
}
